import React from "react";

interface OneCutCornerProps {
  a?: string | number;
  b?: string | number;
  c?: string | number;
  d?: string | number;
  e?: string | number;
  f?: string | number;
  foldType?: string;
  foldDirection?: number;
  arrowColor?: string;
  textColor?: string;
}

const OneCutCorner: React.FC<OneCutCornerProps> = ({
  a = "",
  b = "",
  c = "",
  d = "",
  e = "",
  f = "",
  foldType = "",
  foldDirection = 1,
  arrowColor = "#1E8F31",
  textColor = "#000"
}) => {
  return (
    <svg
      width="250"
      height="230"
      viewBox="-20 0 280 230"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* One Cut Corner */}
      <path
        d="M182 187H62C53.7157 187 47 180.284 47 172V79.3588L89.5 37H182C190.284 37 197 43.7157 197 52V172C197 180.284 190.284 187 182 187Z"
        stroke="#1E8F31"
        strokeWidth="3"
      />

      {/* Arrows */}
      <path
        d="M43 212L49 215.464V208.536L43 212ZM201 212L195 208.536V215.464L201 212ZM48.4 212.6H123V211.4H48.4V212.6ZM123 212.6H195.6V211.4H123V212.6Z"
        fill={arrowColor}
      />
      <path
        d="M87 16L93 19.4641V12.5359L87 16ZM201 16L195 12.5359V19.4641L201 16ZM92.4 16.6H123V15.4H92.4V16.6ZM123 16.6H195.6V15.4H123V16.6Z"
        fill={arrowColor}
      />
      <path
        d="M246 33L242.536 39H249.464L246 33ZM246 190.5L249.464 184.5H242.536L246 190.5ZM245.4 38.4V185.1H246.6V38.4H245.4Z"
        fill={arrowColor}
      />
      <line x1="179" y1="191.4" x2="234" y2="191.4" stroke="#565656" strokeWidth="1.2" />
      <line x1="201" y1="170.4" x2="234" y2="170.4" stroke="#565656" strokeWidth="1.2" />
      <path
        d="M208 171L204.536 177L211.464 177L208 171ZM208 191L211.464 185L204.536 185L208 191ZM207.4 176.4L207.4 185.6L208.6 185.6L208.6 176.4L207.4 176.4Z"
        fill={arrowColor}
      />
      <path
        d="M27 78L23.5359 84L30.4641 84L27 78ZM27 192L30.4641 186L23.5359 186L27 192ZM26.4 83.4L26.4 186.6L27.6 186.6L27.6 83.4L26.4 83.4Z"
        fill={arrowColor}
      />
      <path
        d="M79 16L71.7502 17.9426L77.0574 23.2498L79 16ZM27 68L34.2498 66.0574L28.9426 60.7502L27 68ZM74.4038 19.677L30.677 63.4038L31.5962 64.323L75.323 20.5962L74.4038 19.677Z"
        fill={arrowColor}
      />

      {/* Letters */}
      <text
        xmlSpace="preserve"
        textAnchor="middle"
        fontFamily="Roboto"
        fontSize="12"
        y="107.85673"
        x="224.14267"
        fill={textColor}
      >
        A: {a}
      </text>
      <text
        xmlSpace="preserve"
        textAnchor="middle"
        fontFamily="Roboto"
        fontSize="12"
        y="12.75486"
        x="145.46935"
        fill={textColor}
      >
        B: {b}
      </text>
      <text
        xmlSpace="preserve"
        textAnchor="middle"
        fontFamily="Roboto"
        fontSize="12"
        y="34.38748"
        x="28.26547"
        fill={textColor}
      >
        C: {c}
      </text>
      <text
        xmlSpace="preserve"
        textAnchor="end"
        fontFamily="Roboto"
        fontSize="12"
        y="132.75464"
        x="25.32674"
        fill={textColor}
      >
        D: {d}
      </text>
      <text
        xmlSpace="preserve"
        textAnchor="middle"
        fontFamily="Roboto"
        fontSize="12"
        y="223.77488"
        x="125.2449"
        fill={textColor}
      >
        E: {e}
      </text>
      <text
        xmlSpace="preserve"
        fontFamily="Roboto"
        fontSize="12"
        y="185.81578"
        x="212.34677"
        fill={textColor}
      >
        F: {f}
      </text>

      {/* Bi Fold V */}
      {foldType === "Bi-Fold" && foldDirection === 2 && (
        <path d="M121.5 41L121.5 188" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
      )}

      {/* Tri Fold V */}
      {foldType === "Tri-Fold" && foldDirection === 2 && (
        <>
          <path d="M92 41L92 188" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <path d="M151 41L151 188" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
        </>
      )}

      {/* Quad Fold V */}
      {foldType === "Quad-Fold" && foldDirection === 2 && (
        <>
          <path d="M121.5 41L121.5 188" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <path d="M157 41L157 188" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <path d="M85 41L85 188" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
        </>
      )}

      {/* Five Fold V */}
      {foldType === "Five-Fold" && foldDirection === 2 && (
        <>
          <path d="M80.6001 45L80.6001 188" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <path d="M109.2 40L109.2 188" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <path d="M137.8 40L137.8 188" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <path d="M166.4 40L166.4 188" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
        </>
      )}

      {/* Six Fold V */}
      {foldType === "Six-Fold" && foldDirection === 2 && (
        <>
          <path d="M75.8301 55L75.8301 188" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <path d="M99.66 40L99.66 188" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <path d="M123.49 40L123.49 188" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <path d="M147.32 40L147.32 188" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <path d="M171.15 40L171.15 188" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
        </>
      )}

      {/* Bi Fold H */}
      {foldType === "Bi-Fold" && foldDirection === 1 && (
        <line x1="50" y1="112.4" x2="195" y2="112.4" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
      )}

      {/* Tri Fold H */}
      {foldType === "Tri-Fold" && foldDirection === 1 && (
        <>
          <path d="M50 88.4H195" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="50" y1="135.4" x2="195" y2="135.4" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
        </>
      )}

      {/* Quad Fold H */}
      {foldType === "Quad-Fold" && foldDirection === 1 && (
        <>
          <line x1="50" y1="112.4" x2="195" y2="112.4" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <path d="M50 76.4H195" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <path d="M50 147.4H195" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
        </>
      )}

      {/* Five Fold H */}
      {foldType === "Five-Fold" && foldDirection === 1 && (
        <>
          <line x1="57" y1="70" x2="200" y2="70" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="53" y1="98.6" x2="198" y2="98.6" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="53" y1="127.2" x2="198" y2="127.2" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="53" y1="155.8" x2="198" y2="155.8" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
        </>
      )}

      {/* Six Fold H */}
      {foldType === "Six-Fold" && foldDirection === 1 && (
        <>
          <line x1="65" y1="63.23" x2="198" y2="63.23" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="52" y1="87.06" x2="198" y2="87.06" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="52" y1="110.89" x2="198" y2="110.89" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="52" y1="134.72" x2="198" y2="134.72" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="52" y1="158.55" x2="198" y2="158.55" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
        </>
      )}
    </svg>
  );
};

export default OneCutCorner;

